import { render, staticRenderFns } from "./WineTypeView.vue?vue&type=template&id=13e5750a"
import script from "./WineTypeView.vue?vue&type=script&lang=ts"
export * from "./WineTypeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports